export default __webpack_public_path__ + "static/media/mantra-dao.f599d506.jpg";